import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useParams } from "react-router-dom";
import { secondAxios } from "../../../../../api/axios";

const defaultValue = {
  plant: false,
  plantId: undefined,
  plantProjects: [],
  selectedProjectIndices: [],
  setSelectedProjectIndices: () => {},
  refreshPlantProjects: () => {},
};

const PMSContext = createContext(defaultValue);

export const usePMS = () => useContext(PMSContext);

export const PMSProvider = ({ children, plant = false }) => {
  const { plantId } = useParams();
  const [plantProjects, setPlantProjects] = useState([]);
  const [selectedProjectIndices, setSelectedProjectIndices] = useState([]);
  const [plantName, setPlantName] = useState("");

  const refreshPlantProjects = useCallback(async () => {
    if (!plant || !plantId) {
      setPlantProjects([]);
      setSelectedProjectIndices([]);
      return;
    }

    try {
      const res = await secondAxios.get(`/plant/${plantId}`);
      console.log("res pmssssss", res);
      setPlantName(res.data.name||"");
      const allProjects = Array.isArray(res.data.project)
        ? res.data.project
        : res.data.projects ||
          (res.data.project
            ? [res.data.project]
            : Array.isArray(res.data)
            ? res.data
            : []);

      const filtered = allProjects.filter(
        (p) => p.clientName === process.env.REACT_APP_CLIENT_NAME
      );
      setPlantProjects(filtered);

      // reset selection when plant changes
      setSelectedProjectIndices([]);
    } catch (e) {
      console.error("Failed to load PMS plant projects:", e);
      setPlantProjects([]);
      setSelectedProjectIndices([]);
    }
  }, [plant, plantId]);

  useEffect(() => {
    refreshPlantProjects();
  }, [refreshPlantProjects]);

  const value = useMemo(
    () => ({
      plant,
      plantId,
      plantProjects,
      selectedProjectIndices,
      setSelectedProjectIndices,
      refreshPlantProjects,
      plantName,
    }),
    [
      plant,
      plantId,
      plantProjects,
      selectedProjectIndices,
      refreshPlantProjects,
    plantName,
    ]
  );

  return <PMSContext.Provider value={value}>{children}</PMSContext.Provider>;
};


